/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".global-alert[_ngcontent-%COMP%]{text-align:center;color:#a72834;background:#f8d7da}.reload-btn[_ngcontent-%COMP%]{font-weight:600;color:#a72834}.reload-btn[_ngcontent-%COMP%]:hover{cursor:pointer;text-decoration:underline}.close-btn[_ngcontent-%COMP%]{position:absolute;top:1rem;right:1rem}.close-btn[_ngcontent-%COMP%]:hover{cursor:pointer}"];
export { styles as styles };
